import { Routes } from '@angular/router';
import { PageNotFoundComponent } from '../../application/common/components/page-not-found/page-not-found.component';
import { PageUnderConstructionComponent } from '../../application/common/components/page-under-construction/page-under-construction.component';
import { authGuard } from '../../application/common/guards/auth.guard';
import { noAuthGuard } from '../../application/common/guards/no-auth.guard';
import { AppShellComponent } from '../layout/app-shell/app-shell.component';

export const routes: Routes = [
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },

  {
    path: 'auth',
    canActivate: [noAuthGuard],
    loadChildren: () =>
      import('../../application/authentication/application/routes').then(
        (m) => m.AUTH_ROUTES,
      ),
  },

  {
    path: '',
    component: AppShellComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('../../application/home/application/routes').then(
            (m) => m.HOME_ROUTES,
          ),
      },
      {
        path: 'analysis',
        loadChildren: () =>
          import('../../application/analysis/application/routes').then(
            (m) => m.ANALYSIS_ROUTES,
          ),
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('../../application/profile/application/routes').then(
            (m) => m.PROFILE_ROUTES,
          ),
      },
      {
        path: 'configuration',
        loadChildren: () =>
          import('../../application/configuration/application/routes').then(
            (m) => m.CONFIGURATION_ROUTES,
          ),
      },
      {
        path: 'under-construction',
        component: PageUnderConstructionComponent,
      },
    ],
  },

  { path: '**', component: PageNotFoundComponent },
];
